import { render } from "./BaseLink.vue?vue&type=template&id=59f8dc12&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=js"
export * from "./BaseLink.vue?vue&type=script&lang=js"

import "./BaseLink.vue?vue&type=style&index=0&id=59f8dc12&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f8dc12"]])

export default __exports__